import { Component, OnDestroy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-dialog-confirm',
    templateUrl: './dialog-confirm.component.html',
    styleUrls: ['./dialog-confirm.component.scss'],
    imports: [NgIf, MatDialogTitle]
})
export class DialogConfirmComponent implements OnDestroy {
    dialogRef = inject<MatDialogRef<DialogConfirmComponent>>(MatDialogRef);
    data = inject<{
    title: string;
    message: string;
}>(MAT_DIALOG_DATA);


    result: boolean;

    Fermer() {
        this.result = true;
        this.dialogRef.close();
    }


    ngOnDestroy() {
        this.dialogRef.close();
    }
}
